<div class="category-header">
  <mat-checkbox
    class="custom-checkbox parent"
    (change)="toggleIncludeProductData($event.checked)"
    [checked]="includeProductData"
    color="primary"
    matTooltip="Include product data files in the archive."
    matTooltipPosition="after"
  ></mat-checkbox>
  <h4 class="category-heading">Product Data Files</h4>
  @if (includeProductData) {
    <span class="review-actions">
      <button
        mat-stroked-button
        type="button"
        [disabled]="pdfcConvention == null"
        (click)="openReviewFilenames()"
      >
        Review Filenames &rsaquo;
      </button>
      <button
        mat-stroked-button
        type="button"
        (click)="openReviewFiles()"
      >
        Review Files &rsaquo;
      </button>
    </span>
  }
</div>
@if (includeProductData && !dataConventionConfigured) {
  <div class="category-banner">
    <strong>Data Convention not set.</strong>
    Configure one from
    <a [href]="orgUpdateLink">Organisation settings</a>
    before including product-data files in a collection.
  </div>
}
@if (includeProductData && noPdfcConfigured) {
  <div class="category-banner">
    <strong>Product Data File Convention not set.</strong>
    Configure one from
    <a [href]="orgUpdateLink">Organisation settings</a>
    before including product-data files in a collection.
  </div>
}
@if (includeProductData && !noPdfcConfigured && dataConventionConfigured && blockers != null && blockers.missing > 0) {
  <div class="category-banner">
    <strong>Cannot proceed:</strong>
    {{ blockers.missing }} product-data file{{ blockers.missing === 1 ? '' : 's' }} missing.
    Regenerate them before creating the collection.
  </div>
}
@if (includeProductData) {
  <app-select-all-checkbox
    class="select-all"
    [totalCount]="formatsGeneratedInStep3.length"
    [selectedCount]="selectedFormats.length"
    (toggle)="toggleAllFormats($event)">
    Select all
    @if (blockers != null) {
      <span class="category-meta">
        — {{ selectedFormats.length }} format{{ selectedFormats.length === 1 ? '' : 's' }} selected
        @if (blockers.missing > 0) {
          , <span class="blocker-count missing">{{ blockers.missing }} missing</span>
        }
      </span>
    }
  </app-select-all-checkbox>
  <div class="children">
    @for (format of formatsGeneratedInStep3; track format) {
      <mat-checkbox
        class="custom-checkbox child"
        (change)="toggleFormat(format, $event.checked)"
        [checked]="isFormatSelected(format)"
        color="primary"
      >
        {{ format }}
        @if (filenameIdentifier) {
          <code class="convention-inline">{{ formatConvention(format) }}</code>
        }
      </mat-checkbox>
    }
  </div>
}
